import { Trans } from 'react-i18next';

export function Translation<K extends string = string>({
  i18nKey,
  count = 0,
  values = {},
  children,
  components,
}: {
  i18nKey: K;
  children: React.ReactNode;
  count?: number;
  values?: Record<string, unknown>;
  components?:
    | readonly React.ReactElement[]
    | { readonly [tagName: string]: React.ReactElement };
}) {
  return (
    <Trans
      i18nKey={i18nKey}
      count={count}
      values={values}
      components={components}
    >
      {children}
    </Trans>
  );
}
